import React from 'react'
import { Text, TextVariant } from '@mprolab/uikit'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'

export interface TableHeaderProps {
  headerContent: string[]
}

const TableHeader: React.FC<TableHeaderProps> = ({ headerContent }) => {
  const { t } = useTranslation()
  const { colors } = useTheme()

  return (
    <Grid container ml="16px">
      {headerContent.map((item, index) => {
        const gridSize = () => {
          switch (true) {
            case index === 1:
              return 1.4
            case index === 2:
              return 4.4
            default:
              return 1
          }
        }
        return (
          <Grid item xs={gridSize()} key={index}>
            <Text variant={TextVariant.BODY_SMALL} color={colors.gray6}>
              {t(`stakingPanel.${item}`)}
            </Text>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default TableHeader
